module.exports = __webpack_public_path__ + "img/pop-img-share2.f004df34.png";